import { render, staticRenderFns } from "./subscription_types.page.vue?vue&type=template&id=26d7b24b&"
import script from "./subscription_types.page.vue?vue&type=script&lang=js&"
export * from "./subscription_types.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports